(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Micush: line the category sidebar up with the first product card row (below the filter / sort bar). */
  (function () {
    var raf = 0;

    function align() {
      raf = 0;
      var layout = document.querySelector('.collection-layout--with-sidebar');
      if (!layout) return;
      var side = layout.querySelector('.collection-layout__sidebar');
      var item = layout.querySelector('.product-grid__item');
      if (!side || !item) return;
      var offset = item.getBoundingClientRect().top - layout.getBoundingClientRect().top;
      side.style.marginTop = Math.max(0, Math.round(offset)) + 'px';
    }

    function schedule() {
      if (!raf) raf = requestAnimationFrame(align);
    }

    function init() {
      var main = document.querySelector('.collection-layout--with-sidebar .collection-layout__main');
      if (!main) return;
      schedule();
      if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(main);
      new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    window.addEventListener('load', schedule);
    window.addEventListener('resize', schedule);
  })();

  } catch(e) { console.error(e); }
})();
})();
